import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const colorMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600' },
};

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            探索精彩内容
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            八大内容频道，涵盖电影、电视剧、综艺、动漫、纪录片等丰富类型，满足你的所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-all duration-300 cursor-pointer overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-20 h-20 bg-primary-500/10 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative z-10">
                  <div className={`w-11 h-11 rounded-lg ${colors.bg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${cat.icon} ${colors.text} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-1">{cat.name}</h3>
                  <p className="text-xs text-foreground-500">{cat.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}